import axios from 'axios' 
import config from './config.json'

const auth = axios.create({
	baseURL: config.api_url,
}) 

const token = (headers) =>  {
	const p = axios.create({
		baseURL: config.api_url,
	})
	Object.keys(headers).forEach((header) => 
		p.defaults.headers.common[header] = headers[header]
	)
	return p
}

export default {auth, token }